import {ButtonProps, IconButton} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

const IconCancelButton: React.FC<ButtonProps> = ({...buttonProps}) => {
  return (
    <IconButton {...buttonProps} color='error'>
      {<ClearIcon />}
    </IconButton>
  );
};

export default IconCancelButton;
